export default __webpack_public_path__ + "static/media/pwaDirection3.e906f6c1.png";